import React from 'react';
import { cn } from '@/lib/utils';
import Text from './Text';

/**
 * "Orders  152 orders" — the reference's page header, and the one every list
 * screen in this app now opens with.
 *
 * The count next to the title is not decoration: it is the answer to "did my
 * filter do anything", and it is why the title and the count share a baseline
 * rather than stacking.
 */

export interface PageHeaderProps {
  title: React.ReactNode;
  /** The small grey count beside the title — "152 orders", "76 deliveries". */
  count?: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Buttons on the trailing edge. */
  actions?: React.ReactNode;
  /** Rendered under the title row — a breadcrumb, a venue switcher. */
  children?: React.ReactNode;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  count,
  subtitle,
  actions,
  children,
  className,
}) => (
  <div className={cn('flex flex-wrap items-start justify-between gap-x-4 gap-y-3', className)}>
    <div className="min-w-0">
      <div className="flex items-baseline gap-2.5 min-w-0 flex-wrap">
        <Text variant="h1" as="h1" lines={1}>
          {title}
        </Text>
        {count !== undefined && count !== null ? (
          <Text variant="caption" tone="tertiary" as="span" className="nums">
            {count}
          </Text>
        ) : null}
      </div>
      {subtitle ? (
        <Text variant="body" tone="secondary" as="p" className="mt-1">
          {subtitle}
        </Text>
      ) : null}
      {children}
    </div>

    {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
  </div>
);

export default React.memo(PageHeader);
